/**
 * Country Info section ordering — mirrors iOS CountryInfoView.hasTripStarted.
 */

export type CountryInfoSectionId =
  | 'knowBefore'
  | 'health'
  | 'embassy'
  | 'currency'
  | 'tipping'
  | 'rideHail'
  | 'port';

const BEFORE: CountryInfoSectionId[] = [
  'knowBefore',
  'health',
  'embassy',
  'currency',
  'tipping',
  'rideHail',
  'port',
];

const AFTER: CountryInfoSectionId[] = [
  'currency',
  'tipping',
  'rideHail',
  'port',
  'embassy',
  'health',
  'knowBefore',
];

export function hasTripStarted(
  now: Date,
  tripStartDate: string | null | undefined,
  cityArrivalDate: string | null | undefined
): boolean {
  const raw = (tripStartDate || cityArrivalDate || '').trim();
  if (!raw) return false;
  const ymd = /^(\d{4})-(\d{2})-(\d{2})/.exec(raw);
  const start = ymd
    ? new Date(Number(ymd[1]), Number(ymd[2]) - 1, Number(ymd[3]), 0, 0, 0, 0)
    : new Date(raw);
  if (Number.isNaN(start.getTime())) return false;
  return now.getTime() >= start.getTime();
}

export function orderedCountryInfoSections(
  started: boolean,
  options?: { includePort?: boolean }
): CountryInfoSectionId[] {
  const base = started ? AFTER : BEFORE;
  if (options?.includePort === false) {
    return base.filter((id) => id !== 'port');
  }
  return [...base];
}
